<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>watch_later</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Conceptos de Movimiento de Caja</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          clearable
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Descripción"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">                
                        <tr @click="viewItem(item)">
                            <td class="text-xs-left">{{ item.descripcion }}</td>
                            
                            <td class="text-xs-left">                
                            <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                            <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon></td>
                        </tr>
                      </template>
                    </v-data-table>
                    
                  </v-card >
                </v-flex>
                
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>watch_later</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">
                        <v-icon medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id != null" 
                        :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                        <v-text-field v-model="model.descripcion" label="Descripción" required :disabled="!editMode" v-validate="'required'"
                                    data-vv-name="descripcion" :error-messages="errors.collect('descripcion')"></v-text-field>

                        <h2>Características del Concepto:</h2>

                        <v-row>
                            <v-radio-group v-model="model.signo" row label="Signo" :disabled="!editMode">
                                    <v-radio :value="1" label="Ingreso (1)" ></v-radio>
                                    <v-radio :value="-1" label="Egreso (-1)" ></v-radio>
                            </v-radio-group>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-checkbox label="Genera Movimiento A Otra Caja" v-model="asociarAOtroConcepto" :disabled="!editMode"></v-checkbox>
                            </v-col>
                            <v-col cols="6" v-if="asociarAOtroConcepto">
                                <v-autocomplete v-model="model.conceptoMovimientoAOtraCajaId" :items="conceptosMovimientoCaja" 
                                    item-text="descripcion" item-value="id" label="Concepto Movimiento A Otra Caja" placeholder="Seleccione uno" 
                                    :disabled="!editMode"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-checkbox label="Es de Sistema" v-model="model.esDeSistema" :disabled="!editMode" ></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox label="Imprime Comprobante" v-model="model.imprimeComprobante" :disabled="!editMode"></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col >
                              <v-autocomplete v-model="model.cuentaContableId" :items="cuentasContables" 
                                    item-text="descripcionCompleta" item-value="id" label="Cuenta Contable" placeholder="Seleccione una" 
                                    :disabled="!editMode"></v-autocomplete>

                            </v-col>
                        </v-row>

                        <v-textarea v-model="model.observaciones" label="Observaciones" :disabled="!editMode"
                          ></v-textarea>

                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>

                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Descripción', value: 'descripcion', align: 'left'},
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      model: {},
      tiposGestion: [],
      conceptosMovimientoCaja:[],
      cuentasContables:[],
      asociarAOtroConcepto: false
    };
  },
  async created() {     
      this.getItems();
      this.loadOtrosConceptos();
      this.loadCuentasContables();
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
    respuestasGestionFiltered(){
        if(!this.respuestasGestion) return [];


        Vue.$log.debug(this.respuestasGestion);
        const list = this.respuestasGestion.filter((r) => this.model.tipoGestionId == r.tipoGestionId);

        Vue.$log.debug(list);
      
        return list;
    }
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {
        var result = await http.get('cajas/listconceptosmovimientos?descripcion='+this.search + '&incluirDeSistema=true' + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false') );                                
        
        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()

      try {
        var result = await http.get('cajas/getconceptomovimientobyid/'+id);

        this.model = result;
        
        this.asociarAOtroConcepto = this.model.conceptoMovimientoAOtraCajaId > 0
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {}
        this.asociarAOtroConcepto = false;
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
        const isUpdate = !!this.model.id;
        await this.$validator.validateAll()
        
        if(this.errors.items.length > 0) return;

        if(this.asociarAOtroConcepto)
        {
            if(!this.model.conceptoMovimientoAOtraCajaId)
            {
                this.alertWarning('Debe elegir un concepto a asociar.')
                return;
            }
        }
        else
            this.model.conceptoMovimientoAOtraCajaId = 0;
      
        if (isUpdate) {
            try{
            var result = await http.put('cajas/updateconceptomovimientocaja', JSON.stringify( {concepto:  this.model} ) );
            this.alertSuccess('Los cambios han sido guardados.')
            this.clearAndReload();
            } 
            catch(error){
            // Error
            this.alertError(error)
            }               
        } else {
            try{
            var result = await http.post('cajas/createconceptomovimientocaja', JSON.stringify( {concepto:  this.model} ) );
            this.alertSuccess('Los cambios han sido guardados.')
            this.clearAndReload();
            } 
            catch(error){
            // Error
            Vue.$log.error(error);
            this.alertError(error)
            }         
        }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación del concepto ' + item.descripcion + '?')) {
        try{
            Vue.$log.debug(item);
            var result = await http.delete('cajas/deleteconceptomovimientocaja?id='+item.id );
            this.alertSuccess('El concepto ha sido eliminada.')
            this.clearAndReload();
        }
        catch(error){
            //Error
            Vue.$log.error(error);
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('El concepto no puede ser eliminada debido a que está asociado a otras entidades.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    async loadOtrosConceptos(){
      this.loading = true;
      try{
        var result = await http.get('cajas/listconceptosmovimientos');

        this.conceptosMovimientoCaja = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadCuentasContables(){
      this.loading = true;
      try{
        var result = await http.get('cajas/listcuentascontables');

        this.cuentasContables = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    }
  }
}
</script>